import styled from 'styled-components';

export const TextModal = styled.span`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.travelApproval.modal.modalTextColor};

  & > strong {
    font-weight: 600;
  }
`;

export const ListContainer = styled.div`
  flex-grow: 2;
  height: 100%;
  display: flex;
  justify-content: center;

  @media ${({ theme }) => theme.device.desktop} {
    justify-content: flex-start;
  }
`;
